import { render, staticRenderFns } from "./PointCreditBreakdownList.vue?vue&type=template&id=91087638&scoped=true"
import script from "./PointCreditBreakdownList.vue?vue&type=script&lang=js"
export * from "./PointCreditBreakdownList.vue?vue&type=script&lang=js"
import style0 from "./PointCreditBreakdownList.vue?vue&type=style&index=0&id=91087638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91087638",
  null
  
)

export default component.exports